import { registerQuery, useSuspenseQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import type { InboundDbObjectType } from 'inbound-db-meta-service-client/InboundDbMeta-Service/types';
import Raven from 'raven-js';

const getAppObjectsFromNames = (names: string[]) => {
  return http.get<InboundDbObjectType[]>(
    'inbounddb-meta/v1/object-types/batch-get-by-names',
    {
      query: {
        name: names,
      },
    }
  );
};

const GET_APP_OBJECT_NAMES = registerQuery({
  fieldName: 'appObjectNames',
  args: ['names'],
  fetcher: async ({ names }: { names: string[] }) => {
    if (names.length === 0) {
      return {};
    }
    try {
      const data = await getAppObjectsFromNames(names);

      const objectMap = new Map<string, InboundDbObjectType>(
        data.map((object) => [object.fullyQualifiedName, object])
      );

      return Object.fromEntries(
        names.map((name) => {
          const appObject = objectMap.get(name);
          return [
            name,
            appObject?.singularForm || appObject?.pluralForm || appObject?.name,
          ];
        })
      );
    } catch (error) {
      Raven.captureException(error as Error, {
        extra: { query: 'appObjectNames' },
      });
      // on error, return empty object -- we'll just show the internal names
      return {};
    }
  },
});

export const useFetchAppObjectNames = ({ names }: { names: string[] }) => {
  return useSuspenseQuery(GET_APP_OBJECT_NAMES, {
    variables: { names },
  }).data.appObjectNames;
};
